import { TranslationKeys } from '@/components/language/i18n';
import { MenuProps } from 'antd';

export type MenuItem = Required<MenuProps>['items'][number];
export interface MenuItemBlock {
  label?: string;
  icon?: JSX.Element;
  href?: string;
  children?: MenuItemBlock[];
  isCurrent?: boolean;
  description?: string;
  id: string;
  hideMenu?: boolean;
  position?: ('header' | 'sidebar' | 'home')[];
  secure?: boolean;
  showTransactionBlockList?: boolean;
  onClick?: () => void;
}

export const getMenuItemKeyLabel = (item: Partial<MenuItemBlock>) => {
  return `Menu.${item.id}.label` as TranslationKeys;
};
export const getMenuItemKeyDescription = (item: Partial<MenuItemBlock>) => {
  return `Menu.${item.id}.description` as TranslationKeys;
};

export const MenuItems: MenuItemBlock[] = [
  {
    id: 'Home',
    //label: 'Home',
    href: '/home',
    position: ['sidebar'],
  },

  {
    //label: 'Profile',
    id: 'Profile',
    href: '/profile',
    position: ['header'],
  },
  {
    id: 'Settings',
    href: '/settings',
    position: ['header'],
  },
  {
    id: 'SecureVault',
    href: '/secureVault',
    position: ['sidebar', 'home'],
    secure: true,
    showTransactionBlockList: true,
  },
  {
    id: 'SecureSync',
    href: '/secureSync',
    //label: 'Secure Sync',
    showTransactionBlockList: true,
    position: ['sidebar', 'home'],
  },
  // {
  //   id: 'SecurePassword',
  //   href: '/securePassword',
  //   secure: true,
  //   showTransactionBlockList: true,
  //   //label: 'Secure Password',
  //   position: ['sidebar'],
  // },
  {
    id: 'SecureInBox',
    href: '/secureInBox',
    //label: 'Secure InBox',
    showTransactionBlockList: true,
    position: ['sidebar', 'home'],
  },
  {
    id: 'Login',
    //label: 'Login',
    href: '/login',
  },

  {
    id: 'Register',
    //label: 'Register',
    href: '/register',
  },
  {
    id: 'Download',
    label: 'Download',
    href: '/download',
  },
  {
    id: 'SmartShare',
    label: 'Smart Share',
    href: '/smartshare',
  },
  // {
  //   id: 'signOff',
  //   //label: 'Logout',
  //   href: '/logout',
  //   // icon: <LogoutOutlined />,
  //   position: ['header'],
  // },
];

export const headerMenuItems: MenuItemBlock[] = [
  {
    id: 'Settings',
    href: '/settings',

    position: ['header'],
  },
  {
    id: 'Logout',
    href: '#',

    position: ['header'],
  },
  {
    //label: 'Profile',
    id: 'Profile',
    href: '/profile',
    position: ['header'],
  },
];
